module.exports = __webpack_public_path__ + "static/img/cMRIp2.c57df381.png";